import React, { Component} from 'react';
import PropTypes from 'prop-types';


import shouldPureComponentUpdate from 'react-pure-render/function';

import {greatPlaceStyle, greatPlaceStyleHover} from './my_great_place_with_controllable_hover_styles.js';

import "./html-hint.min.css";

import cameraIcon from'../images/camera.png';
import audioIcon from'../images/audio.png';
import selectIcon from'../images/selector.png';
import optionIcon from'../images/options.png';
import textIcon from'../images/text_entry.png';
import measureIcon from'../images/measurment.png';
import startIcon from'../images/start.png';
import endIcon from'../images/end.png';
import recordingIcon from'../images/recording.png';
import photoIcon from'../images/photo.png';


//<link rel="stylesheet" href="html-hint.min.css"></link>

export default class MyGreatPlaceWithControllableHover extends Component {
  static propTypes = {
    // use hover from controllable
    hover: PropTypes.bool,
    text: PropTypes.string,
    type: PropTypes.string,
    title: PropTypes.string
  };

  static defaultProps = {};

  shouldComponentUpdate = shouldPureComponentUpdate;

  constructor(props) {
    super(props);
  }

  render() {
    //console.log('MyGreatPlaceWithControllableHover: ' + this.props.hover);
    const style = this.props.hover ? greatPlaceStyleHover : greatPlaceStyle;
    //console.log('props');
    //console.log(this.props);
    var icon = null;
    switch (this.props.type) {
      case 'START':
        icon = startIcon;
        break;
      case 'END':
        icon = endIcon;
        break;
      case 'CAMERA':
        icon = cameraIcon;
        break;
      case 'RECORDING':
        icon = recordingIcon;
        break;
      case 'PHOTO':
        icon = photoIcon;
        break;
      case 'AUDIO':
        icon = audioIcon;
        break;
      case 'OPTIONS':
        icon = optionIcon;
        break;
      case 'TEXTS':
        icon = textIcon;
        break;
      case 'MEASUREMENT':
        icon = measureIcon;
        break;
      case 'SELECTORS':
        icon = selectIcon;
        break;
    }
    return (
       <div className="hint hint--html hint--info hint--top" style={Object.assign({ backgroundImage: `url(${icon})` }, style)}>

          <div className="hint__content">
            {this.props.title}
          </div>
       </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/my_great_place_with_controllable_hover.js